import { GeoEnum } from '@models/DTO/geo.enum';

export const currencies = [
  { id: 1, name: 'KZT' },
  { id: 2, name: 'RUB' },
  { id: 3, name: 'KGS' },
  { id: 4, name: 'UZS' },
  { id: 5, name: 'USD' },
  { id: 6, name: 'TMT' },
  { id: 7, name: 'AED' },
  { id: 8, name: 'TJS' },
];

export enum CountryKey {
  KZ = 'kz',
  KG = 'kg',
  UZ = 'uz',
  RU = 'ru',
  TJ = 'tj',
}

interface PhoneConfig {
  mask: string;
  prefix: string;
  numberLength?: number;
}

interface CountryConfig {
  label: string;
  value: CountryKey;
  code: CountryKey;
  flagPath: string;
  phone: PhoneConfig;
  currency?: {
    code: string;
    name: string;
    symbol: string;
    id: number;
  };
  geoEnum?: GeoEnum;
}

export const countryConfig: Record<CountryKey, CountryConfig> = {
  [CountryKey.KZ]: {
    label: 'Казахстан',
    value: CountryKey.KZ,
    code: CountryKey.KZ,
    flagPath: 'assets/flags/kz.svg',
    phone: {
      mask: '(000) 000-00-00',
      prefix: '+7 ',
      numberLength: 10,
    },
    currency: {
      code: 'KZT',
      name: 'тенге',
      symbol: '₸',
      id: 1,
    },
    geoEnum: GeoEnum.KZ,
  },
  [CountryKey.KG]: {
    label: 'Кыргызстан',
    value: CountryKey.KG,
    code: CountryKey.KG,
    flagPath: 'assets/flags/kg.svg',
    phone: {
      mask: '(000) 00-00-00',
      prefix: '+996 ',
      numberLength: 9,
    },
    currency: {
      code: 'KGS',
      name: 'сом',
      symbol: '⊆',
      id: 3,
    },
    geoEnum: GeoEnum.KG,
  },
  [CountryKey.UZ]: {
    label: 'Узбекистан',
    value: CountryKey.UZ,
    code: CountryKey.UZ,
    flagPath: 'assets/flags/uz.svg',
    phone: {
      mask: '(00) 000-00-00',
      prefix: '+998 ',
      numberLength: 9,
    },
    currency: {
      code: 'UZS',
      name: 'сум',
      symbol: 'Som',
      id: 4,
    },
    geoEnum: GeoEnum.UZ,
  },
  [CountryKey.RU]: {
    label: 'Россия',
    value: CountryKey.RU,
    code: CountryKey.RU,
    flagPath: 'assets/flags/ru.svg',
    phone: {
      mask: '(000) 000-00-00',
      prefix: '+7 ',
      numberLength: 10,
    },
    currency: {
      code: 'RUB',
      name: 'рубль',
      symbol: '₽',
      id: 2,
    },
    // not geoEnum
  },
  [CountryKey.TJ]: {
    label: 'Таджикистан',
    value: CountryKey.TJ,
    code: CountryKey.TJ,
    flagPath: 'assets/flags/tj.svg',
    phone: {
      mask: '(00) 000-00-00',
      prefix: '+992 ',
      numberLength: 9,
    },
    currency: {
      code: 'TJS',
      name: 'сомони',
      symbol: 'с.',
      id: 8,
    },
    geoEnum: GeoEnum.TJ,
  },
};
